<ng-template
  #overlay="cdkConnectedOverlay"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayHasBackdrop]="showBackdrop"
  [cdkConnectedOverlayOpen]="visible"
  [cdkConnectedOverlayPositions]="supportedPositions"
  [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
  (detach)="hide()"
  (positionChange)="onPositionChange($event)"
  (overlayOutsideClick)="onOutsideClick($event)"
>
  <div
    class="phx-tooltip"
    [class.phx-padding-none]="paddingNone"
    [class.phx-toggle-tip]="isToggleTipVisible"
    [class.phx-is-toggle-tip]="isToggleTip"
    [@fadeInOut]
    [ngClass]="classMap"
    (mouseenter)="setMouseState(true)"
    (mouseleave)="setMouseState(false)"
    cdkTrapFocus
  >
    <div class="phx-tooltip-content">
      <span *ngIf="showCloseIcon" class="phx-tooltip-close" (click)="onCloseIconClick()">
        <i phx-icon [phxIcon]="closeIcon" [size]="16" [color]="closeIconColor"></i>
      </span>
      <div class="phx-tooltip-arrow"></div>
      <div class="phx-tooltip-inner" [style.max-width]="maxWidthInPx">
        <div *ngIf="title" class="phx-tooltip-title">
          <ng-container *ngIf="titleIsTemplate" [ngTemplateOutlet]="$any(title)" [ngTemplateOutletContext]="{ $implicit: tooltipContext }"></ng-container>
          <ng-container *ngIf="!titleIsTemplate">{{ title }}</ng-container>
        </div>
        <div *ngIf="subtitle" class="phx-tooltip-subtitle">
          <ng-container *ngIf="subtitleIsTemplate" [ngTemplateOutlet]="$any(subtitle)" [ngTemplateOutletContext]="{ $implicit: tooltipContext }"></ng-container>
          <ng-container *ngIf="!subtitleIsTemplate">{{ subtitle }}</ng-container>
        </div>
        <div #tooltipContent *ngIf="content" class="phx-tooltip-content" [ngClass]="{ 'phx-no-title': !title }" tabindex="-1">
          <ng-container *ngIf="contentIsTemplate" [ngTemplateOutlet]="$any(content)" [ngTemplateOutletContext]="{ $implicit: tooltipContext }"></ng-container>
          <ng-container *ngIf="!contentIsTemplate">{{ content }}</ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
